import { BookedEventPriceCategory, EventPriceCategory } from '../shared/types'

const getDefaultEventPriceCategories = (eventPriceCategories: EventPriceCategory[], memberAge?: number) => {
  const defaultEventPrices: BookedEventPriceCategory[] = []
  if (memberAge) {
    eventPriceCategories.map((priceCategory) => {
      if ((priceCategory.ageFrom && memberAge && priceCategory.ageFrom <= memberAge) || !priceCategory.ageFrom) {
        if ((priceCategory.ageTo && memberAge && priceCategory.ageTo >= memberAge) || !priceCategory.ageTo) {
          if (priceCategory.defaultCount > 0 && priceCategory.id) {
            defaultEventPrices.push({
              eventPriceCategoryId: priceCategory.id,
              quantity: priceCategory.defaultCount,
            })
          }
        }
      }
    })
  }
  return defaultEventPrices
}

export default getDefaultEventPriceCategories
